<template>
  <div class="form-field-div" :class="defineDivSize">
    <div class="form-label-div" :class="{ disabled: disabled }">
      <label :for="id">{{ $tc(label, 1) }}</label>
    </div>

    <span
      class="form-input-span"
      :class="{ noUnderline: inputType === 'checkbox', disabled: disabled }"
    >
      <input
        v-if="inputType === undefined || inputType === 'input'"
        :type="defineType"
        :value="value"
        @input="emitInput($event.target.value)"
        :id="id"
        class="form-input"
        :class="{ defineInputSize, 'hide-arrow': hideArrow }"
        :placeholder="placeholder"
        spellcheck="false"
        :disabled="disabled"
        autofocus
      />

      <textarea
        v-if="inputType === 'textarea'"
        :value="value"
        @input="emitInput($event.target.value)"
        :id="id"
        class="form-input"
        :class="defineInputSize"
        :placeholder="placeholder"
        spellcheck="false"
        :disabled="disabled"
      />

      <slot
        v-if="
          inputType === 'select' ||
            inputType === 'datepicker' ||
            inputType === 'checkbox'
        "
        :class="defineInputSize"
      />
     
    </span>
  </div>
</template>

<script>

import { mapActions } from "vuex";

export default {
  name: "FormInput",

  props: [
    "label",
    "type",
    "id",
    "required",
    "disabled",
    "size",
    "placeholder",
    "value",
    "inputType",
    "automaticLabel",
    "hideArrow"
  ],

  computed: {
    defineDivSize() {
      if (this.size === "small") {
        return "s-form-field-div";
      }
      if (this.size === "medium") {
        return "m-form-field-div";
      }
      if (this.size === "large") {
        return "l-form-field-div";
      }
      if (this.size === "xlarge") {
        return "xl-form-field-div";
      }

      return "s-form-field-div";
    },

    defineInputSize() {
      if (this.size === "small") {
        return "s-form-input";
      }
      if (this.size === "medium") {
        return "m-form-input";
      }
      if (this.size === "large") {
        return "l-form-input";
      }
      if (this.size === "xlarge") {
        return "xl-form-input";
      }
      if (this.size == parseInt(this.size)) {
        this.$nextTick(() => {
          let element;
          let input = this.$el.querySelector("input");
          let textarea = this.$el.querySelector("textarea");

          if (input) {
            element = input;
          }

          if (textarea) {
            element = textarea;
          }

          element.style.width = this.size + "px";
        });
      }
      return "s-form-input";
    },

    defineType() {
      return !this.type ? "text" : this.type;
    },

    defineInputType() {
      return !this.inputType ? "input" : this.inputType;
    }
  },

  mounted() {
    let div = this.$el;
    let input = this.$el.querySelector("input");
    let textarea = this.$el.querySelector("textarea");
    if (this.required !== undefined) {
      div.classList.add("required");
      input.required = "required";
    }

    if (this.disabled !== undefined) {
      if (input) {
        input.disabled = this.disabled;
      }
      if (textarea) {
        textarea.disabled = this.disabled;
      }
    }
  },

  methods: {
    ...mapActions(["GET_AUTOMATIC_LABEL"]),

    emitInput(value) {
      this.$emit("input", value);
    },
  }
};
</script>

<style scoped>
.form-field-div {
  width: 95px;
  display: inline-table;
  margin: 4px 12px;
}

.form-field-div > label {
  vertical-align: top;
}

.m-form-field-div {
  width: 155px;
}

.l-form-field-div {
  width: 220px;
}

.xl-form-field-div {
  width: 280px;
}

.noUnderline > .v-input--checkbox {
  margin-top: 3px;
}

.noUnderline::after {
  border-bottom: 0;
}

.noUnderline > .v-input--checkbox:nth-child(n + 2) {
  margin-top: -10px;
}

.hide-arrow::-webkit-outer-spin-button,
.hide-arrow::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/FormInput.vue